import ImportedPatient from 'models/ImportedPatient';
import { useCoordinatePatientsStore } from 'stores/patientFiltersStore';

import CoordinateListItem from './CoordinateListItem';

function PatientList({
  patients,
  onAddToPortfolio,
}: {
  patients: ImportedPatient[];
  onAddToPortfolio?: (value: string) => void;
}) {
  const { search } = useCoordinatePatientsStore();
  return (
    <>
      {patients.map((patient) => (
        <CoordinateListItem
          key={`${patient.id}-${search}`}
          hospital={patient.transferredFrom?.name ?? ''}
          onAddToPortfolio={onAddToPortfolio}
          {...patient}
        />
      ))}
    </>
  );
}

export default PatientList;
